import { Fragment, useEffect, useRef } from "react";
import Modal from "../../../components/Modal";
import { getResults } from "../../../services/CombineService";
import { useAxiosInstance } from "../../../services/Interceptor";
import combineResults from "../../../utils/combineResultsData";

export default function EventResultsAthleteDashboard({
  eventId,
  userId,
  closeModal,
}) {
  const apiInstance = useAxiosInstance();

  // Create refs for the elements you need to update
  const totalFeetRefs = useRef({});
  const totalInchesRefs = useRef({});
  const auxRefs = useRef({});

  useEffect(() => {
    getCombineResults();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, eventId]);

  const getCombineResults = async () => {
    const response = await getResults(apiInstance, eventId, userId);
    if (response && response.length > 0) {
      response.forEach((item) => {
        item.athleteTestDetails.forEach((itemDetails) => {
          if (itemDetails && itemDetails.fieldId) {
            if (itemDetails.fieldId <= 6) {
              // update use refs
              if (totalInchesRefs.current[itemDetails.fieldId]) {
                totalInchesRefs.current[itemDetails.fieldId].innerText =
                  itemDetails.stageValue || 0;
              }
            }

            if (itemDetails.fieldId === 7) {
              totalInchesRefs.current[itemDetails.fieldId].innerText =
                itemDetails.reps || 0;
              totalFeetRefs.current[itemDetails.fieldId].innerText =
                itemDetails.stageValue || 0;
            }

            if (itemDetails.fieldId > 8) {
              if (itemDetails.fieldId === 9) {
                const aux1 =
                  auxRefs.current[`item-aux-1-${itemDetails.fieldId}`];
                const aux2 =
                  auxRefs.current[`item-aux-2-${itemDetails.fieldId}`];
                const aux3 =
                  auxRefs.current[`item-aux-3-${itemDetails.fieldId}`];
                const aux4 =
                  auxRefs.current[`item-aux-4-${itemDetails.fieldId}`];
                const totalFeet = totalFeetRefs.current[itemDetails.fieldId];
                const totalInches =
                  totalInchesRefs.current[itemDetails.fieldId];

                if (aux1 && aux2 && aux3 && aux4) {
                  let feet_aux1 = Math.floor(itemDetails.auxiliary1 / 12);
                  let remainingInches_aux1 = itemDetails.auxiliary1 % 12;
                  let feet_aux2 = Math.floor(itemDetails.auxiliary2 / 12);
                  let remainingInches_aux2 = itemDetails.auxiliary2 % 12;
                  let feet_total = Math.floor(itemDetails.stageValue / 12);
                  let remainingInches_total = itemDetails.stageValue % 12;

                  aux1.innerText = feet_aux1.toFixed(3) || 0;
                  aux2.innerText = remainingInches_aux1.toFixed(3) || 0;
                  aux3.innerText = feet_aux2.toFixed(3) || 0;
                  aux4.innerText = remainingInches_aux2.toFixed(3) || 0;
                  if (totalFeet)
                    totalFeet.innerText = feet_total.toFixed(3) || 0;
                  if (totalInches)
                    totalInches.innerText =
                      remainingInches_total.toFixed(3) || 0;
                }
              } else if (itemDetails.fieldId > 9) {
                // Lógic to others inputs
                if (totalFeetRefs.current[itemDetails.fieldId]) {
                  let feet = Math.floor(itemDetails.stageValue / 12);
                  totalFeetRefs.current[itemDetails.fieldId].innerText =
                    feet.toFixed(3) || 0;
                }
                if (totalInchesRefs.current[itemDetails.fieldId]) {
                  let remainingInches = itemDetails.stageValue % 12;
                  totalInchesRefs.current[itemDetails.fieldId].innerText =
                    remainingInches.toFixed(3) || 0;
                }
              }
            }
          }
        });
      });
    }
  };

  return (
    <Modal isOpen={true} onClose={closeModal} title="Results from Combine">
      <div className="text-xl font-medium uppercase px-4 py-4">
        Event Results
      </div>

      <div className="overflow-y-auto max-h-[450px] ml-2 px-4">
        {combineResults.map((itemResult, indexResult) => (
          <div
            className={`border border-blue-700 rounded px-4 py-2 items-center mb-3 ${
              indexResult === 0 ? "mt-4" : ""
            }`}
            key={indexResult}
          >
            <div className="font-normal">
              <b className="text-[#5057FF]">{itemResult.attempt}: </b>{" "}
              {itemResult.name}
            </div>

            {itemResult.test.map((itemTest, indexTest) => (
              <Fragment key={indexTest}>
                {itemTest.aux && (
                  <>
                    <div className="grid grid-cols-2 gap-4 my-4 bg-[#E6E3E3]">
                      <div className="flex items-center py-1">
                        <span className="ml-2">Standing Height: </span>
                        <span
                          ref={(el) =>
                            (auxRefs.current[`item-aux-1-${itemTest.fieldId}`] =
                              el)
                          }
                          className="ml-2"
                        ></span>
                        <span className="ml-1">ft</span>
                        <span
                          ref={(el) =>
                            (auxRefs.current[`item-aux-2-${itemTest.fieldId}`] =
                              el)
                          }
                          className="ml-2"
                        ></span>
                        <span className="ml-1">in</span>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 my-4 bg-[#E6E3E3]">
                      <div className="flex items-center py-1">
                        <span className="ml-2">Jump Height: </span>
                        <span
                          ref={(el) =>
                            (auxRefs.current[`item-aux-3-${itemTest.fieldId}`] =
                              el)
                          }
                          className="ml-2"
                        ></span>
                        <span className="ml-1">ft</span>
                        <span
                          ref={(el) =>
                            (auxRefs.current[`item-aux-4-${itemTest.fieldId}`] =
                              el)
                          }
                          className="ml-2"
                        ></span>
                        <span className="ml-1">in</span>
                      </div>
                    </div>
                  </>
                )}
                <div className="grid grid-cols-2 gap-4 my-4 even:bg-[#E6E3E3]">
                  <div className="flex items-center py-1">
                    {itemTest.stageAsField ? (
                      <>
                        {itemTest.aux && <span className="ml-2">Total: </span>}
                        <span
                          ref={(el) =>
                            (totalFeetRefs.current[itemTest.fieldId] = el)
                          }
                          className="ml-2"
                        ></span>
                        {itemResult.unit === "inches" && (
                          <span className="ml-1">ft</span>
                        )}
                        {itemResult.unit === "lbs" && (
                          <span className="ml-1">lbs</span>
                        )}
                      </>
                    ) : (
                      itemTest.stageLabel && (
                        <span className="pl-6 pr-4"> {itemTest.stage}: </span>
                      )
                    )}
                    <>
                      <span
                        ref={(el) =>
                          (totalInchesRefs.current[itemTest.fieldId] = el)
                        }
                        className="ml-2"
                      ></span>
                      {itemResult.unit === "inches" && (
                        <span className="ml-1">in</span>
                      )}
                      {itemResult.unit === "lbs" && (
                        <span className="ml-1">reps</span>
                      )}
                      {itemResult.unit === "seconds" && (
                        <span className="ml-1">sec</span>
                      )}
                    </>
                  </div>
                </div>
              </Fragment>
            ))}
          </div>
        ))}
      </div>

      <div className="flex justify-end border-t border-gray-200 px-4 py-3">
        <button
          type="button"
          onClick={closeModal}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Close
        </button>
      </div>
    </Modal>
  );
}
